import { render } from "./KommentareView.vue?vue&type=template&id=a13a48a4&scoped=true"
import script from "./KommentareView.vue?vue&type=script&lang=js"
export * from "./KommentareView.vue?vue&type=script&lang=js"

import "./KommentareView.vue?vue&type=style&index=0&id=a13a48a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13a48a4"]])

export default __exports__